import {
    ExternalLinkIcon,
    HamburgerMenuIcon,
} from '@radix-ui/react-icons';
import '../App.css';
import logo from '../icon.png';

import { useContext, useEffect, useState } from 'react';
import { NavLink } from 'react-router';
import { AuthContext } from '../context/AuthContext';
import { RateLimitContext } from '../context/RateLimitContext';
import { Button } from './ui/button';
import {
    NavigationMenu,
    NavigationMenuContent,
    NavigationMenuItem,
    NavigationMenuLink,
    NavigationMenuList,
    NavigationMenuTrigger,
    navigationMenuTriggerStyle,
} from "./ui/navigation-menu";
import {
    Sheet,
    SheetContent,
    SheetDescription,
    SheetHeader,
    SheetTitle,
    SheetTrigger,
} from "./ui/sheet";
import MembershipBanner from './membershipBanner';
import TestingBanner from './testingBanner';

function MenuItems({ closeSheet }) {
    return (
        <>
            <NavigationMenuItem>
                <NavigationMenuTrigger>Tävlingar</NavigationMenuTrigger>
                <NavigationMenuContent className='z-10 w-min-52 w-fit text-sm'>
                    <ul className='flex flex-col gap-3 p-6'>
                        <li>
                            <NavigationMenuLink asChild className='flex h-full w-full flex-col p-2 rounded-md hover:bg-accent'>
                                <NavLink to='/upcoming' onClick={closeSheet} >
                                    Kommande tävlingar
                                </NavLink>
                            </NavigationMenuLink>
                        </li>
                        <li>
                            <NavigationMenuLink asChild className='flex h-full w-full flex-col p-2 rounded-md hover:bg-accent'>
                                <NavLink to='/bunny-rankings' onClick={closeSheet}>
                                    Rankinglistor
                                </NavLink>
                            </NavigationMenuLink>
                        </li>
                        <li>
                            <NavigationMenuLink asChild className='flex h-full w-full flex-col p-2 rounded-md hover:bg-accent'>
                                <NavLink to='/results' onClick={closeSheet}>
                                    Resultat
                                </NavLink>
                            </NavigationMenuLink>
                        </li>
                    </ul>
                </NavigationMenuContent>
            </NavigationMenuItem>
            <NavigationMenuItem>
                <NavigationMenuTrigger>Kaninregister</NavigationMenuTrigger>
                <NavigationMenuContent className='z-10 w-min-52 w-fit text-sm'>
                    <ul className='flex flex-col gap-3 p-6'>
                        <li>
                            <NavigationMenuLink asChild className='flex h-full w-full flex-col p-2 rounded-md hover:bg-accent'>
                                <NavLink to='/bunnies' onClick={closeSheet}>
                                    Kaniner
                                </NavLink>
                            </NavigationMenuLink>
                        </li>
                        <li>
                            <NavigationMenuLink asChild className='flex h-full w-full flex-col p-2 rounded-md hover:bg-accent'>
                                <NavLink to='/farms' onClick={closeSheet}>
                                    Gårdar
                                </NavLink>
                            </NavigationMenuLink>
                        </li>
                    </ul>
                </NavigationMenuContent>
            </NavigationMenuItem>
            <NavigationMenuItem>
                <NavigationMenuLink asChild className={navigationMenuTriggerStyle()} onClick={closeSheet}>
                    <NavLink to='/clubs'>
                        Föreningar
                    </NavLink>
                </NavigationMenuLink>
            </NavigationMenuItem>
        </>
    );
}

function UserMenu({ closeSheet, auth, logout }) {

    return (
        <NavigationMenuItem>
            <NavigationMenuTrigger>{auth.user?.first_name} {auth.user?.last_name}</NavigationMenuTrigger>
            <NavigationMenuContent className='z-10 min-w-52 w-fit text-sm'>
                <ul className='flex flex-col gap-3 p-6'>
                    <li>
                        <NavigationMenuLink asChild className='flex h-full w-full flex-col p-2 rounded-md hover:bg-accent'>
                            <NavLink to='/mycompetitions' onClick={closeSheet}>
                                Mina tävlingar
                            </NavLink>
                        </NavigationMenuLink>
                    </li>
                    <li>
                        <NavigationMenuLink asChild className='flex h-full w-full flex-col p-2 rounded-md hover:bg-accent'>
                            <NavLink to='/mybunnies' onClick={closeSheet}>
                                Mina kaniner
                            </NavLink>
                        </NavigationMenuLink>
                    </li>
                    {(auth.user?.superadmin || auth.user?.roleInClub === 'admin') && (
                        <li>
                            <NavigationMenuLink asChild className='flex h-full w-full flex-col p-2 rounded-md hover:bg-accent'>
                                <NavLink to='/system' onClick={closeSheet}>
                                    System
                                </NavLink>
                            </NavigationMenuLink>
                        </li>
                    )}
                    {(auth.user?.superadmin || auth.user?.bunnyadmin) && (
                        <li>
                            <NavigationMenuLink asChild className='flex h-full w-full flex-col p-2 rounded-md hover:bg-accent'>
                                <NavLink to='/bunny-approval' onClick={closeSheet}>
                                    Kaniner att godkänna
                                </NavLink>
                            </NavigationMenuLink>
                        </li>
                    )}
                    <li>
                        <NavigationMenuLink asChild className='flex h-full w-full flex-col p-2 rounded-md hover:bg-accent'>
                            <NavLink to={'/profile/' + auth.user?.id} onClick={closeSheet}>
                                Redigera profil
                            </NavLink>
                        </NavigationMenuLink>
                    </li>
                    <li>
                        <NavigationMenuLink asChild className='flex h-full w-full flex-col p-2 rounded-md hover:bg-accent'>
                            <NavLink to='/login' onClick={() => {
                                logout();
                                window.location.reload();
                            }} className='hidden md:block'>
                                Logga ut
                            </NavLink>
                        </NavigationMenuLink>
                    </li>
                </ul>
            </NavigationMenuContent>
        </NavigationMenuItem>
    );
}

function Header() {
    const { auth, isLoggedIn, logout } = useContext(AuthContext);
    const [isOpen, setIsOpen] = useState(false);
    const closeSheet = () => setIsOpen(false);

    return (
        <>
            {/* <TestingBanner /> */}
            <MembershipBanner />

            <div className='w-full h-16 flex justify-center items-center shadow-md'>
                <div className='w-5/6 flex'>
                    <div className='w-3/4 flex flex-row'>
                        <NavLink to='/' className='mr-3 flex items-center gap-3 hover:underline font-semibold'>
                            <img src={logo} className='AppLogo' alt='STAMP logo'></img>STAMP
                        </NavLink>
                        <NavigationMenu className='hidden md:block'>
                            <NavigationMenuList>
                                <MenuItems closeSheet={closeSheet} />
                            </NavigationMenuList>
                        </NavigationMenu>
                    </div>
                    <div className='w-1/4 flex flex-row justify-end items-center gap-3'>
                        <Sheet open={isOpen} onOpenChange={setIsOpen} className='md:hidden'>
                            <SheetTrigger className='md:hidden'><HamburgerMenuIcon className='size-8' /></SheetTrigger>
                            <SheetContent className='flex flex-col gap-6 justify-between' onOpenAutoFocus={(event) => event.preventDefault()}>
                                <div className='flex flex-col gap-6'>
                                    <SheetHeader className='flex flex-row items-center'>
                                        <NavLink to='/' className='mr-3' onClick={closeSheet}>
                                            <img src={logo} className='AppLogo' alt='STAMP logo'></img>
                                        </NavLink>
                                        <SheetTitle>STAMP</SheetTitle>
                                        <SheetDescription></SheetDescription>
                                    </SheetHeader>
                                    <NavigationMenu orientation='vertical'>
                                        <NavigationMenuList className='flex flex-col items-start gap-3' orientation='vertical'>
                                            <MenuItems closeSheet={closeSheet} />
                                            {isLoggedIn() && <UserMenu closeSheet={closeSheet} auth={auth} logout={logout} />}
                                        </NavigationMenuList>
                                    </NavigationMenu>
                                </div>
                                {isLoggedIn() ? (
                                    <NavLink to='/login' onClick={() => { closeSheet(); logout(); window.location.reload(); }}>
                                        <Button variant='secondary' className='w-full'>Logga ut</Button>
                                    </NavLink>
                                ) : (
                                    <NavLink to='/login' onClick={closeSheet}>
                                        <Button className='w-full'>Logga in</Button>
                                    </NavLink>
                                )}
                            </SheetContent>
                        </Sheet>
                        {isLoggedIn() ? (
                            <NavigationMenu className='hidden md:block'>
                                <NavigationMenuList>
                                    <UserMenu closeSheet={closeSheet} auth={auth} logout={logout} />
                                </NavigationMenuList>
                            </NavigationMenu>
                        ) : (
                            <NavLink to='/login' className='hidden md:block'>
                                <Button>Logga in</Button>
                            </NavLink>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

const DevTools = ({ rawToken, auth }) => {
    const { latestFamilyTreeFetch } = useContext(RateLimitContext);

    const [timeLeft, setTimeLeft] = useState({});

    const getExpiryDateFromJWT = (token) => {
        const payload = JSON.parse(atob(token.split('.')[1]));

        // Remove 5s from expiry date to account for latency
        //payload.exp = payload.exp - 5;

        return payload.exp * 1000; // Return timestamp in milliseconds
    };

    const calculateTimeLeft = (expiryTimestamp) => {
        const now = Date.now();
        const difference = expiryTimestamp - now;
        let timeLeft = '';

        if (difference > 0) {
            const seconds = Math.floor(difference / 1000);
            timeLeft = `${seconds}s`;
        } else {
            timeLeft = 'Expired';
        }

        return timeLeft;
    };

    useEffect(() => {
        const tokenExpiryTimestamp = getExpiryDateFromJWT(rawToken);
        const familyTreeExpiryTimestamp = latestFamilyTreeFetch + 1000 * 3;

        const interval = setInterval(() => {
            setTimeLeft((prev) => ({
                ...prev,
                token: calculateTimeLeft(tokenExpiryTimestamp),
                familyTree: calculateTimeLeft(familyTreeExpiryTimestamp),
            }));
        }, 100);

        return () => clearInterval(interval);
    }, [rawToken, latestFamilyTreeFetch]);

    return (
        <>
            {auth?.user && (
                <div>
                    <p>T {timeLeft.token} | FT {timeLeft.familyTree}</p>
                </div>
            )}
        </>
    );
};

export default Header;
